"use strict";
/**
 * Telemetry contract — the surface `app` use-cases depend on (injected via `deps`).
 *
 * Deliberately tiny and infrastructure-only: this package imports nothing from
 * `core`/`fs`/`app`. It carries no Loom domain vocabulary — the event names and
 * their props live in the app-layer taxonomy (packages/app/src/telemetry). That
 * split is what lets the transport/consent/identity core be reused verbatim in
 * other repos (e.g. chord-flow) with a different event vocabulary and key.
 */
Object.defineProperty(exports, "__esModule", { value: true });
